<template>
	<div class="mainContainer etcCoopHeroContainer">
		<div class="etcCoopHeroContent">
			<h1>{{ $t("homepage.title") }}</h1>
			<h3>{{ $t("homepage.description") }}</h3>
			<p>{{ $t("homepage.teaser") }}</p>
		</div>
	</div>
</template>
